// src/api/auth.js
// GHL Legacy — session-based authentication (no Cognito).

const EDGE_ORIGIN = import.meta.env.VITE_EDGE_ORIGIN || "https://api.yebo-ai.com";
const STORAGE_KEY = "YG_SESSION_TOKEN";
const STATIC_BEARER = (import.meta.env.VITE_PROXY_BEARER || "").trim();

let sessionToken = null;

/** No-op — Cognito not used in legacy mode. */
export function setCognitoToken() {}

/**
 * Get the current auth token.
 * Uses session token or static bearer.
 */
export function getAuthToken() {
  return sessionToken || STATIC_BEARER || "";
}

/**
 * Fetch a session token from the backend for a given locationId.
 */
export async function fetchSessionToken(locationId) {
  if (!locationId) return null;

  try {
    const cached = sessionStorage.getItem(STORAGE_KEY);
    if (cached) {
      const { token, locationId: cachedLoc, expiresAt } = JSON.parse(cached);
      if (cachedLoc === locationId && expiresAt > Date.now() + 60_000) {
        sessionToken = token;
        return token;
      }
    }
  } catch {}

  const base = String(EDGE_ORIGIN).replace(/\/+$/, "");
  const url = `${base}/api/auth/session`;

  try {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ locationId }),
    });

    if (!res.ok) {
      console.warn(`[auth] Session fetch failed: ${res.status}`);
      return null;
    }

    const data = await res.json();
    if (data.token) {
      sessionToken = data.token;
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
          token: data.token,
          locationId,
          expiresAt: Date.now() + (data.expiresIn || 86400) * 1000,
        }));
      } catch {}
      return data.token;
    }
  } catch (err) {
    console.warn("[auth] Session fetch error:", err);
  }

  return null;
}

/**
 * Clear the session token.
 */
export function clearSessionToken() {
  sessionToken = null;
  try { sessionStorage.removeItem(STORAGE_KEY); } catch {}
}
